import { useAuth } from 'context/Auth';

export function isKcbVerifiedUser(user) {
  return user?.examinationAndTreatmentLicenseInfo?.kcbVerified === true;
}

export default function useIsKcbVerified() {
  const { user } = useAuth();
  return isKcbVerifiedUser(user);
}
